var pageNameDefinition = {
    accessstart: 'AccessStart',
    appgallery: 'AppGallery',
    assist: 'Assist',
    automate: 'Automate',
    bizchat: 'BizChat',
    browse: 'Browse',
    clipchampstart: 'ClipchampStart',
    chat: 'Chat',
    content: 'Content',
    create: 'Create',
    calendarstart: 'CalendarStart',
    catchUp: 'CatchUp',
    collect: 'Collect',
    delvastart: 'DelveStart',
    draft: 'Draft',
    excelstart: 'ExcelStart',
    excelcontent: 'ExcelContent',
    exceltemplates: 'ExcelTemplates',
    feed: 'Feed',
    fluidcontent: 'FluidContent',
    fluidstart: 'FluidStart',
    formsgroupforms: 'FormsGroupForms',
    formsmyforms: 'FormsMyForms',
    formsstart: 'FormsStart',
    formstemplates: 'FormsTemplates',
    officehome: 'OfficeHome',
    m365apps: 'M365Apps',
    mailstart: 'MailStart',
    modernmycontent: 'ModernMyContent',
    mycontent: 'MyContent',
    myforms: 'MyForms',
    news: 'News',
    notebookstart: 'NotebookStart',
    onedrivestart: 'OneDriveStart',
    onenotestart: 'OneNoteStart',
    outlookstart: 'OutlookStart',
    pdfstart: 'PdfStart',
    people: 'People',
    plannerstart: 'PlannerStart',
    powerbistart: 'PowerBiStart',
    powerpointstart: 'PowerPointStart',
    powerpointcontent: 'PowerPointContent',
    powerpointtemplates: 'PowerPointTemplates',
    prepare: 'Prepare',
    projectstart: 'ProjectStart',
    publisherstart: 'PublisherStart',
    search: 'Search',
    searchfilesscoped: 'SearchFilesScoped',
    searchpersonscoped: 'SearchPersonScoped',
    searchsitescoped: 'SearchSiteScoped',
    searchpersonscopedoverview: 'SearchPersonScopedOverview',
    sharepointstart: 'SharePointStart',
    streamstart: 'StreamStart',
    swaystart: 'SwayStart',
    swaytemplates: 'SwayTemplates',
    tasksstart: 'TasksStart',
    teamsstart: 'TeamsStart',
    unknown: 'Unknown',
    videostart: 'VideoStart',
    videocontent: 'VideoContent',
    visiostart: 'VisioStart',
    visiocontent: 'VisioContent',
    visiotemplates: 'VisioTemplates',
    whiteboardstart: 'WhiteboardStart',
    wordstart: 'WordStart',
    wordcontent: 'WordContent',
    wordtemplates: 'WordTemplates',
    yammerstart: 'YammerStart',
};
export function getPageType(pageName) {
    if (pageName) {
        if (pageName === 'MyContent') {
            return 'Default';
        }
        else if (pageName.endsWith('Start')) {
            return 'Start';
        }
        else if (pageName.endsWith('Templates')) {
            return 'Templates';
        }
        else if (pageName.endsWith('Content')) {
            return 'Content';
        }
        else if (pageName === 'SearchPersonScoped') {
            return 'Person';
        }
        else if (pageName === 'SearchSiteScoped') {
            return 'Site';
        }
        else if (pageName === 'FormsGroupForms') {
            return 'GroupForms';
        }
        else if (pageName === 'FormsMyForms') {
            return 'MyForms';
        }
        else {
            return 'Default'; // AppGallery, Create, OfficeHome, Search
        }
    }
    else {
        return 'Other';
    }
}
export function getPageAppName(pageName) {
    var appName;
    if (pageName) {
        if (pageName === 'MyContent') {
            return pageName;
        }
        else if (pageName.endsWith('Start') ||
            pageName.endsWith('Templates') ||
            pageName.endsWith('Content')) {
            appName = pageName
                .replace('Start', '')
                .replace('Templates', '')
                .replace('Content', '');
            return appName;
        }
        else if (pageName.startsWith('Search')) {
            return 'Search';
        }
        else if (pageName.startsWith('Forms')) {
            return 'Forms';
        }
        else if (pageName === 'OfficeHome') {
            return 'Home';
        }
        else {
            return pageName; // AppGallery, Create, OfficeHome
        }
    }
    else {
        return '';
    }
}
export function convertRouteToPage(route) {
    var currentRoute = (route === null || route === void 0 ? void 0 : route.route) === 'Pwa' ? 'OfficeHome' : route === null || route === void 0 ? void 0 : route.route;
    var pageName = currentRoute !== undefined
        ? "".concat((route === null || route === void 0 ? void 0 : route.app) ? route.app : '').concat(currentRoute)
        : undefined;
    return pageName !== undefined
        ? convertRawPageToPageName(pageName)
        : 'Unknown';
}
export function convertRawPageToPageName(page) {
    if (page) {
        var pageLCase = page.toLowerCase();
        // e.g. ffca97e5-0569-c88c-ac30-7c5717e2e5aeM365Apps
        if (pageLCase.endsWith('m365apps')) {
            return 'M365Apps';
        }
        if (pageLCase === 'pwa') {
            return 'OfficeHome';
        }
        var convertedPageName = pageNameDefinition[pageLCase];
        return convertedPageName !== undefined ? convertedPageName : 'Unknown';
    }
    return 'Unknown';
}
//# sourceMappingURL=getPageInfo.js.map